'use strict';

var cache = {};

/**
 * Checks if the given element has a child with a 'data-pid' attribute equal to the given ID.
 *
 * @function
 * @name hasChildWithId
 * @param {string} id - The ID to check for.
 * @param {jQuery} $element - The jQuery element to check.
 * @returns {boolean} - True if the element has a child with a 'data-pid' attribute equal to the ID, false otherwise.
 */
function hasChildWithId(id, $element) {
    var $children = $element.find('[data-pid="' + id + '"]');

    return $children.length > 0;
}

/**
 * Moves the given jQuery element to its nearest parent with the class 'product'.
 *
 * @function
 * @name moveElementToProductTileParent
 * @param {jQuery} $tileRecItem - The jQuery element to move.
 */
function moveElementToProductTileParent($tileRecItem) {
    var $elementParent = $tileRecItem.closest('.js-product-wrapper');

    $tileRecItem.insertAfter($elementParent);
}

/**
 * Adds an icon to the title of the JATC right-aligned modal and binds a click event to it that hides the modal and shows the shoppable content modal.
 *
 * @function
 * @name addIconToModalTitle
 */
function addIconToModalTitle() {
    var $modalTitle = cache.$jatcRightAlignedModal.find('.modal-title');

    if ($modalTitle.length > 0) {
        $modalTitle.find('.back-btn').removeClass('d-none');

        $modalTitle.find('.back-btn').on('click', function () {
            cache.$jatcRightAlignedModal.modal('hide');
            cache.$shoppableContentModal.modal('show');
        });
    }
}

/**
 * Adds the 'modal-with-scroll' class to the modal-body element.
 *
 * @function
 * @name addClassToModalContent
 */
function addClassToModalContent() {
    var $modalContent = cache.$jatcCenterAlignedModal.find('.modal-body');

    if ($modalContent.length > 0) {
        $modalContent.addClass('modal-with-scroll');
    }
}

/**
 * Updates the CBT shoppable content with the specified label.
 *
 * @function
 * @name updateCbtShoppableContent
 * @param {jQuery} $el - The jQuery element.
 * @param {string} label - The label to update the modal with.
 * @param {boolean} isRecItem - Whether or not the item is a recommendation item.
 */
function updateCbtShoppableContent($el, label, isRecItem) {
    var dataLayer = {
        'event'      : 'eventCBT',
        'eventTypes' : 'click',
        'action'     : isRecItem ? 'Shoppable Content - Carousel' : 'Shoppable Content',
        'label'      : label
    };

    $el.attr('data-cbt', JSON.stringify(dataLayer));
}

/**
 * Adds the 'icon-with-text' class to buttons with non-empty '.bbw-sc-cta-text' elements.
 *
 * @function
 * @name handleIconWithText
 */
function handleIconWithText() {
    var $buttons = $('.js-shoppable-products');

    $buttons.each(function () {
        var $this = $(this);

        if ($this.find('.bbw-sc-cta-text').text() !== '') {
            $this.addClass('icon-with-text');
        }
    });
}

/**
 * Disables the 'js-add-all-to-cart-btn' button if any of the product tiles in the shoppable modal are unavailable.
 *
 * @function
 * @name disableButtonIfSoldOut
 */
function disableButtonIfSoldOut() {
    var $mainProducts = $('.js-product-wrapper:not(.d-none)');
    var $addToCartBtns = $mainProducts.find('.js-product-tile .add-to-cart');
    var disabled = false;

    $addToCartBtns.each(function () {
        var $this = $(this);

        if ($this.prop('disabled')) {
            disabled = true;
            return false;
        }
    });

    cache.$shoppableContentModalGeneralBtn.attr('disabled', disabled);
}

/**
 * Add events to the shoppable modal to handle the OneTrust banner and Zendesk widget.
 *
 * @function
 * @name addModalEvents
 * @param {JQuery} $modal - The Shoppable Modal
 */
function addModalEvents($modal) {
    $modal.on('show.bs.modal', function () {
        if (typeof zE === 'function') {
            zE('webWidget', 'hide');  // eslint-disable-line
        }
    });

    $modal.on('shown.bs.modal', function () {
        var $banner = $('#onetrust-banner-sdk');
        var $this = $(this);
        var $modalContent = $this.find('.modal-content');

        $modalContent.css('height', '100vh');

        if ($banner.is(':visible')) {
            var heightDiff = $banner.height();
            var currentHeight = $modalContent.height();
            $modalContent.height(currentHeight - heightDiff);

            $(document).on('click', '#onetrust-accept-btn-handler, .onetrust-close-btn-handler', function () {
                $modalContent.css('height', '100vh');
            });
        }

        addIconToModalTitle();
        $(document).trigger('sc.rec.slider');

        cache.$body.addClass('modal-open');
        cache.$body.css('padding-right', '19px');
        $this.css('padding-right', '19px');
    });

    $modal.on('hide.bs.modal', function () {
        if (typeof zE === 'function') {
            zE('webWidget', 'show');  // eslint-disable-line
        }

        $modal.find('.modal-scrollable-container').scrollTop(0);
    });

    $modal.on('hidden.bs.modal', function () {
        if (cache.$jatcRightAlignedModal.is(':hidden') || cache.$jatcRightAlignedModal.length === 0) {
            var $icon = cache.$jatcRightAlignedModal.find('.modal-title .back-btn');

            $icon.addClass('d-none');
        } else {
            cache.$body.addClass('modal-open');
            cache.$body.css('padding-right', '19px');
            cache.$jatcRightAlignedModal.css('padding-right', '19px');
        }
    });

    $(document).on('click', '.js-add-all-to-cart-btn', function () {
        addClassToModalContent();
    });
}

/**
 * Sends a POST request to change the product displayed in a shoppable content item container.
 *
 * @function
 * @name changeProduct
 * @param {string} url - The URL to send the POST request to.
 * @param {string} productId - The ID of the product to load and render in the shoppable content item container.
 * @param {jQuery} $element - The jQuery element that triggered the change product event.
 */
function changeProduct(url, productId, $element, cbtATBAction) {
    if (!url || productId.length === 0) {
        return;
    }

    $element.closest('.js-bbw-sc-item-container').spinner().start();
    $.ajax({
        method: 'POST',
        url: url,
        data: {
            'productId': productId
        }
    }).done(function (response) {
        $('<div class="js-product-wrapper d-none"' + ' data-pid="' + productId + '">' + response + '</div>').insertBefore($element.closest('.js-sc-rec-slider-wrapper'));

        $(document).trigger('shoppableContent:ModalLoaded', { '$modalBody': $element.closest('.js-modal-body'), 'cbtATBAction': cbtATBAction });

        var $tileItemContainer = $element.closest('.js-bbw-sc-item-container');

        $tileItemContainer.find('.js-product-wrapper').addClass('d-none');
        $tileItemContainer.find('[data-pid="' + $element.find('span').data('product-id') + '"]').removeClass('d-none');

        cache.$body.trigger('ratingsAndReviews:init');
        disableButtonIfSoldOut();
    }).always(function () {
        $element.closest('.js-bbw-sc-item-container').spinner().stop();
    });
}

/**
 * Handles the behavior of the shoppable content recommendation sliders.
 *
 * @function
 * @name handleScRecs
 */
function handleScRecs(cbtATBAction) {
    $('.js-sc-rec-slider-wrapper').each(function () {
        var $this = $(this);

        moveElementToProductTileParent($this);
    });

    var $scRecSliderItems = $('.js-sc-rec-slider-item');

    $scRecSliderItems.each(function () {
        var $this = $(this);

        updateCbtShoppableContent($this, $this.find('span').data('product-id'), true);
    });

    $scRecSliderItems.on('click', function () {
        var $el = $(this);
        var $tileItemContainer = $el.closest('.js-bbw-sc-item-container');

        $tileItemContainer.find('.js-sc-rec-slider-item').removeClass('selected');
        $el.addClass('selected');

        if (!hasChildWithId($el.find('span').data('product-id'), $tileItemContainer)) {
            changeProduct($el.data('change-product-url'), $el.find('span').data('product-id'), $el, cbtATBAction);
        } else {
            $tileItemContainer.find('.js-product-wrapper').addClass('d-none');
            $tileItemContainer.find('[data-pid="' + $el.find('span').data('product-id') + '"]').removeClass('d-none');
            disableButtonIfSoldOut();
        }
    });
}

/**
* Updates the CBT action attribute with the page name
* @param {Object} $modalBody - the jQuery object of the modal body
* @param {string} cbtATBAction - the CBT action to update
*/
function updateCBTActionWithPage($modalBody, cbtATBAction) {
    var $addToCartElements = $modalBody.find('.add-to-cart');

    if (typeof cbtATBAction === 'undefined' || cbtATBAction === '' || $modalBody.length === 0) {
        return;
    }

    $addToCartElements.each(function (i, el) {
        if (typeof $(el).data('cbt') === 'undefined') {
            return;
        }

        var dataLayer = JSON.parse(el.dataset.cbt);

        dataLayer.action = cbtATBAction;

        el.setAttribute('data-cbt', JSON.stringify(dataLayer));
    });
}

/**
 * Sends a POST request to load the specified products and renders them in the shoppable modal.
 *
 * @function
 * @name addProductsAndRenderModal
 * @param {Array} contentProducts - An array of product IDs to load and render in the shoppable modal.
 * @param {string} modalTitle - The title to display in the shoppable modal.
 * @param {string} modalGeneralBtnText - The text to display on the general button in the shoppable modal.
 */
function addProductsAndRenderModal(contentProducts, modalTitle, modalGeneralBtnText, modalGenetalCbtLabel, cbtATBAction) {
    var url = $('[data-load-products-url]').data('load-products-url');

    if (!url || contentProducts.length === 0) {
        return;
    }

    $.spinner().start();
    $.ajax({
        method: 'POST',
        url: url,
        data: {
            'productsIds': contentProducts
        }
    }).done(function (response) {
        var $modalBody = cache.$shoppableContentModal.find('.js-modal-body');
        var $modalTitle = cache.$shoppableContentModal.find('.js-modal-title');
        var $modalGeneralBtn = cache.$shoppableContentModal.find('.js-add-all-to-cart-btn');

        $modalBody.html(response);
        $modalTitle.text(modalTitle);
        $modalGeneralBtn.text(modalGeneralBtnText);

        addModalEvents(cache.$shoppableContentModal);
        updateCbtShoppableContent($modalGeneralBtn, modalGenetalCbtLabel, false);

        cache.$shoppableContentModal.modal('show');

        $(document).trigger('shoppableContent:ModalLoaded', { '$modalBody': $modalBody, 'cbtATBAction': cbtATBAction });
        cache.$body.trigger('ratingsAndReviews:init');
        disableButtonIfSoldOut();
        handleScRecs(cbtATBAction);
    }).always(function () {
        $.spinner().stop();
    });
}

module.exports = {
    initCache: function () {
        cache.$body = $('body');
        cache.$shoppableContentToggle = $('.js-shoppable-products');
        cache.$shoppableContentModal = $('#shoppableModal');
        cache.$jatcRightAlignedModal = $('.js-bbw-add-to-bag-right-modal');
        cache.$jatcCenterAlignedModal = $('.js-bbw-add-to-bag-center-modal');
        cache.$shoppableContentModalGeneralBtn = $('.js-add-all-to-cart-btn');
    },
    init: function () {
        cache.$shoppableContentToggle.each(function () {
            var $this = $(this);
            var cbtLabel = $this.data('cbt-label');


            updateCbtShoppableContent($this, cbtLabel, false);
        });

        cache.$shoppableContentToggle.on('click', function () {
            var $this = $(this);
            var $shoppableContainer = $this.closest('.js-shoppable-container');

            if ($shoppableContainer.data('is-shoppable-content')) {
                var contentProducts = $shoppableContainer.data('content-products');
                var modalTitle = $shoppableContainer.data('modal-title');
                var modalGeneralBtnText = $shoppableContainer.data('modal-general-btn-text');
                var modalGenetalCbtLabel = $shoppableContainer.data('modal-general-btn-cbt-label');
                var cbtATBAction = $this.data('cbt-atb-action');

                addProductsAndRenderModal(contentProducts, modalTitle, modalGeneralBtnText, modalGenetalCbtLabel, cbtATBAction);
            }
        });

        $(document).on('shoppableContent:ModalLoaded', function (e, data) {
            updateCBTActionWithPage(data.$modalBody, data.cbtATBAction);
        });

        handleIconWithText();
    },
};
